/* eslint-disable spellcheck/spell-checker */
import { Injectable } from '@angular/core';

import { TableMode } from '../models/communication/app-enums.model';
import { AppEventType, PlayerCountChangeEvent } from '../models/communication/app-events.model';
import { AppState } from '../models/communication/app-state.model';
import { YEventPayload } from '../models/y-protocol.model';

export type Plugin = (state: AppState, event: YEventPayload<AppEventType>, containerNode: HTMLElement) => void;
/**
 * PluginService exposes the array of plugin functions that get called
 * every time the state or event stream emit values.
 *
 * It is intended for a specific business logic and requirements
 * that would otherwise pollute the app.component with unnecessary details.
 *
 * For now, the function signature is based on the current plugin requirements.
 * In the future, a more general interface should be defined.
 *
 */
@Injectable({
    providedIn: 'root'
})
export class PluginService {
    readonly plugins: Plugin[] = [
        /**
         * When the number of players increases in online tableMode,
         * show the animation effect by adding the class to the containerNode
         * and removing it after the animation ends.
         */
        (state: AppState, event: YEventPayload<AppEventType>, containerNode: HTMLElement): void => {
            if (state.configuration.tableMode !== TableMode.Online) {
                return;
            }

            const className = 'fade-in-out';
            const { name, data } = event;

            if (name === AppEventType.PlayerCountChange) {
                if ((data as PlayerCountChangeEvent).count > (state.playerCount || 0)) {
                    containerNode.classList.add(className);
                    const onAnimationEnd = (): void => {
                        containerNode.classList.remove(className);
                        containerNode.removeEventListener('animationend', onAnimationEnd);
                    };
                    containerNode.addEventListener('animationend', onAnimationEnd);
                }
            }
        }
    ];
}
